import { AppRouteObject } from "./types";

export type OrderNumberRoute = Pick<AppRouteObject, "orderNumberQueryParam"> & {
  path?: string;
};

const orderNumberParamPattern = /:(orderNumber|order)(?=\/|$)/;

const addQueryParam = (path: string, key: string, value: string) => {
  const [pathWithoutHash, hash = ""] = path.split("#");
  const [pathname, queryString = ""] = pathWithoutHash.split("?");
  const searchParams = new URLSearchParams(queryString);

  searchParams.set(key, value);

  const query = searchParams.toString();
  const hashSuffix = hash ? `#${hash}` : "";

  return `${pathname}${query ? `?${query}` : ""}${hashSuffix}`;
};

export const routeRequiresOrderNumber = (route: OrderNumberRoute) =>
  Boolean(route.path?.match(orderNumberParamPattern) || route.orderNumberQueryParam);

export const buildOrderNumberRoutePath = (route: OrderNumberRoute, orderNumber: string) => {
  const trimmedOrderNumber = orderNumber.trim();

  if (!route.path || !trimmedOrderNumber) {
    return route.path || "";
  }

  if (route.orderNumberQueryParam) {
    return addQueryParam(route.path, route.orderNumberQueryParam, trimmedOrderNumber);
  }

  return route.path.replace(orderNumberParamPattern, encodeURIComponent(trimmedOrderNumber));
};
